import * as type from '../../types';


const createSubscriptionState = {
    loading: false,
    response: null,
    error: null,
  };

const updateSubscriptionState = {
    loading: false,
    response: null,
    error: null,
}

const initialState = {
    subscriptions: [], // Stores the list of subscriptions
    loading: false,// Indicates loading state for API calls
    error: null,// Stores any error messages
};

 
  
  export const subscriptionReducer = (state = createSubscriptionState, action) => {
    console.log('Reducer Action Received:', action); // Debug incoming action
    switch (action.type) {
        case type.SUBSCRIPTION_CREATE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case type.SUBSCRIPTION_CREATE_SUCCESS:
            return {
                ...state,
                loading: false,
                response: action.response, // Store the API response
                error: null,
            };
        case type.SUBSCRIPTION_CREATE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error, // Store the error message
            };
        default:
            return state;
    }
};


export const viewSubscriptionReducer = (state = updateSubscriptionState, action) => {
    switch (action.type) {
      case type.SUBSCRIPTIONS_FETCH_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case type.SUBSCRIPTIONS_FETCH_SUCCESS:
        return {
          ...state,
          loading: false,
          subscriptions: action.subscriptions, // Handle fetched data
        };
      case type.SUBSCRIPTIONS_FETCH_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.error,
        };
      default:
        return state;
    }
  };

  export const updateSubscriptionReducer = (state = initialState, action) => {
      switch (action.type) {
          case type.SUBSCRIPTION_UPDATE_REQUEST:
              return {
                  ...state,
                  loading: true,
                  error: null,
              };
          case type.SUBSCRIPTION_UPDATE_SUCCESS:
              return {
                  ...state,
                  loading: false,
                  response: action.response,
              };
          case type.SUBSCRIPTION_UPDATE_FAILURE:
              return {
                  ...state,
                  loading: false,
                  error: action.error,
              };
          default:
              return state;
      }
  };
  